export const FETCH_GET_PRODUCTS = 'FETCH_GET_PRODUCTS';
export const FETCH_GET_SEARCH_PRODUCTS = 'FETCH_GET_SEARCH_PRODUCTS';
export const SELECT_PRODUCT = 'SELECT_PRODUCT';
export const SAVE_SELECT_PRODUCT = 'SAVE_SELECT_PRODUCT';
export const SELECT_VARIATION = 'SELECT_VARIATION';
export const FETCH_GET_VARIATION_IMAGES = 'FETCH_GET_VARIATION_IMAGES';
